module.exports = "https://www.niulinkcloud.com/_next/static/media/mp-node.f501e17f00fcffbb9a7d6a94bf4b6faa.jpg";